import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-storage',
  templateUrl: './storage.component.html',
  styleUrls: ['./storage.component.css']
})
export class StorageComponent implements OnInit {
  @Input() labels: any;
  data = {
    "buffer": 0.22,
    "440bar": {
      "high": 0.75,
      "mid": 0.2,
      "low": 0.0
    },
    "900bar": {
      "high": 0.1,
      "mid": 0.8,
      "low": 1.0
    }
  }
  constructor() { }

  ngOnInit() {
  }
  onUpdate(data: any) {
    this.data = data;
  }
  getData(val, max){
    if(val == null) return 0;
    else{
      let width = 222;
      return width/max * val;
    }
  }
  getLabelValue(val:number, max:number){
    if(val>max) val = max;
    if(val == null) return "0%";
    else{
      let _num = (100.0 / max*val);
      return Math.round( _num ).toString() + "%";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/chart/storage/storage.component.ts